import { AnchorNode } from '../anchor/index';
import { NodeTextNavigation } from './NodeTextNavigation';
import { resolvePathWithOffset } from './resolvePathWithOffset';

export function getTextLengthByPath(root: AnchorNode, start: string, end: string) {
    const matchStart = resolvePathWithOffset(root, start);
    const matchEnd = resolvePathWithOffset(root, end);
    if (!matchStart || !matchEnd) { return -1; }
    const textStart = new NodeTextNavigation(matchStart.anchor.node).domNode();
    const textEnd = new NodeTextNavigation(matchEnd.anchor.node).domNode();
    const backwards = new NodeTextNavigation(matchEnd.anchor.node);
    const countBackwards = backwards.countBackwards(textStart);
    if (backwards.domNode()) { return countBackwards - matchStart.offset + matchEnd.offset; }
    const forwards = new NodeTextNavigation(matchStart.anchor.node);
    const countFowards = forwards.countBackwards(textEnd);
    if (forwards.domNode()) { return (countFowards - matchEnd.offset + matchStart.offset) * -1; }
    return -1;
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/getTextLengthByPath.tsx